import { Box } from "@mui/material";
import { styled } from "@mui/system";
import { Colors } from "./theme";

export const StyledDashboardHeader = styled(Box)(() => ({
  display: "inline-block",
  "& h1": {
    display: "inline-block",
    color: Colors.primary,
    fontSize: "20px",
    marginBottom: "5px",
    width: "fit-content",
    fontWeight: 600,
    display: "inline-block",
  },
}));